module.exports = __webpack_public_path__ + "static/img/tuzheng_05.e3b844e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tuzheng_05.png
// module id = WNmh
// module chunks = 1